import { Box, Text } from '@chakra-ui/react'

export const LiveMonitoring = () => {
  return (
    <Box p={4} bg="white" borderRadius="lg" shadow="sm">
      <Text fontSize="lg" fontWeight="bold" mb={4}>Live Monitoring</Text>
      {/* Graphs and KPIs will go here */}
    </Box>
  )
}
